<template>
    <div id="component" class="container-fluid p-0">
        <div class="toolbar">
            <header-component :report_id="this.$props.report_id"></header-component>
        </div>
        <success-component
                v-if="success.length > 0"
                :message="success">
        </success-component>
        <error-component
                v-if="exceptions.length > 0"
                v-bind="exceptions[0]">
        </error-component>
        <div class="row m-0">
            <div class="col-md-10 col-sm-12 report-body">
                <div v-if="parameters.length > 0" class="mt-3">
                    <parameters-component></parameters-component>
                </div>
                <grid-layout :layout.sync="elements" :cols="{ lg: 40, md: 34, sm: 10, xs: 8, xxs: 4 }"
                             :col-num="30" :row-height="8" :is-draggable="edit" :is-resizable="edit"
                             :is-mirrored="false" :vertical-compact="true" :margin="[10 , 10]"
                             :use-css-transforms="false" :responsive="true">
                    <grid-item v-for="(element, index) in elements" :key="element.i" :class="{ 'editMode' : edit }"
                               :autoSize="true" :x="element.x" :y="element.y" :w="element.w" :h="element.h"
                               :i="element.i" class="border"
                               @resize="resizeEvent" :verticalCompact="false" :drag-ignore-from="'p, a, button'"
                               :style="{overflow: element.type == 'chart'? 'auto': 'none'}">
                        <div class="item-settings btn-group mr-1">
                            <div v-if="edit">
                                <a href="javascript: void(0)" @click="removeItem(index)" v-b-tooltip.hover title="Delete" class="btn btn-link btn-lg p-0 mr-1">
                                    <font-awesome-icon icon="trash-alt" />
                                </a>
                                <component :is="`${element.type}-settings`" :id="element.id" :data="element.data" ref="chartCom" :type="element.type"></component>
                            </div>
                        </div>
                        <component :is="`${element.type}-component`" :id="element.i" :ref="`chartComponent${element.id}`" :type="element.type"
                                   :data="element.data" :show="true" :exportOption="!edit">
                        </component>
                    </grid-item>
                </grid-layout>
            </div>
            <div class="col-md-2 col-sm-2 p-0">
                <toolbar-component :visualization_id="visualization_id"></toolbar-component>
            </div>
        </div>
    </div>
</template>
<script>
    import { GridLayout, GridItem } from 'vue-grid-layout';
    import TextComponent from './Text.vue';
    import ChartComponent from '../../components/Chart.vue';
    import BigNumberComponent from '../../components/BigNumber.vue'
    import { mapState } from 'vuex';
    import ErrorComponent from '../../components/ErrorView.vue';
    import SuccessComponent from '../../components/Success.vue';
    import ToolbarComponent from '../../components/Toolbar.vue';
    import ChartSettings from '../../components/ChartSettings.vue';
    import BigNumberSettings from '../../components/BigNumberSettings.vue';
    import HeaderComponent from './Header.vue';
    import ParametersComponent from './Parameters.vue';

    export default {
        props: {
            report_id: {
                required: false
            },
            visualization_id: {
                required:false
            }
        },
        components: {
            GridLayout,
            GridItem,
            TextComponent,
            BigNumberComponent,
            ErrorComponent,
            SuccessComponent,
            ChartComponent,
            ToolbarComponent,
            ChartSettings,
            BigNumberSettings,
            HeaderComponent,
            ParametersComponent,
        },
        data () {
            return {
                isDraggable: true,
                isResizable: true,
                preview: false,
                unwatch: '',
            }
        },
        methods: {
            exportChart(id) {
                this.$refs['chartComponent'+id][0].export();
            },
            reload() {
                this.$store.commit('reports/SET_PARAMETERS');
            },
            removeItem(index) {
                this.elements.splice(index, 1);
            },
            resizeEvent(i, newH, newW, newHPx, newWPx) {
                if (this.elementIsChart(i)) {
                    let element = this.elements.find(element => element.i ===i);
                        element.data.width = newWPx - 20;
                        element.data.height = newHPx - 20;
                        this.$store.commit('reports/UPDATE_GRID_ELEMENT', element);
                }
            },
            elementIsChart(i) {
                return (this.elements.find(element => element.i === i).type === 'chart');
            },
        },
        created() {
            if (this.report_id) {
                let payload = {
                    report_id: this.report_id
                };
                this.$store.dispatch('reports/fetchReport', payload);
            } else {
                this.$store.commit('reports/SET_REPORT_TITLE', 'Untitled Report');
            }
            this.unwatch = this.$store.watch(
                (state)=>
                    this.$store.state.organizationSelected
                ,
                (newValue, oldValue)=>{
                    this.$store.dispatch('reports/setInitialStatus');
                    this.$router.replace({ name: 'report.create' });
                    this.$store.dispatch('clearMessages');
                },
            );
        },
        beforeDestroy() {
            this.$store.commit('visualizations/SET_CHARTDATA_INITIAL_STATE');
            this.$store.dispatch('reports/setInitialStatus');
            this.$store.commit('visualizations/SET_VISUALIZATION_PARAMETERS', []);
            this.$store.commit('visualizations/SET_PARAMETERS');
            this.$store.dispatch('clearMessages');
            this.unwatch();
        },
        beforeRouteLeave (to, from, next) {
            let editDestination = [
                'visualization.edit',
                'bigNumber.edit',
                'query.edit'
            ];
            if (from.name === 'report.create' && editDestination.includes(to.name)) {
                this.$swal({
                    title: 'Do you want to save your report?',
                    type: 'question',
                    width: '350px',
                    showCancelButton: true,
                    cancelButtonText: 'No',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Yes'
                }).then((result) => {
                    if (result.value) {
                        this.$store.dispatch('reports/create');
                    }
                    next();
                })
            } else {
                if (from.name === 'report.edit' && editDestination.includes(to.name)) {
                    this.$store.dispatch('reports/update', this.report_id).then(() => {
                        next()
                    })
                } else {
                    next()
                }
            }
        },
        computed : {
            ...mapState('reports', {
                edit: 'edit',
                parameters: 'parameters'
            }),
            ...mapState({
                success: 'success',
                exceptions: 'exceptions'
            }),
            elements: {
                get() {
                    return this.$store.state.reports.elements;
                },
                set(value) {
                    this.$store.commit('reports/SET_REPORT_ELEMENTS', value);
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .editMode {
        background-color: #f1f1f1fb;
        border-radius: 5px;
    }

    .report-body {
        height: calc(100vh - 158px);
        overflow-y: auto;
    }

    .swal2-container {
        width: 100px;
    }

    .vue-grid-layout {
        margin-top: 13px;
        margin-left: -10px;
    }
</style>
